import { connect } from 'react-redux'
import * as selector from '../../state/instance-detail/selector'
import TechnicalLog from '../instance-detail/TechnicalLog'

const mapStateToProps = (state, props) => {
    return {
        context: selector.selectProcessContext(state),
        processLogList: selector.selectProcessLogList(state),
    }
}

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(TechnicalLog)



// WEBPACK FOOTER //
// ./src/modules/process/component/task-widget/TechnicalLogContainer.js